import { InputType } from "../types";

export const ArraySortInput: InputType = [{ value: "['Z', 'a', 'z', 'ä', 9, 10]", type: 'string' }];

